import React from "react";
import "./LandingPage.css";

import banner1 from "./assets/banner1.jpg"; // dimensioni: 696 x 182
import banner2 from "./assets/banner2.jpg"; // dimensioni: 696 x 182
import banner3 from "./assets/banner3.jpg"; // banner più alto

import logo from "./assets/expert-logo.png"
const stores = [
  {
    name: "Expert City Caporale",
    addresses: [
      { city: "Roma Tiburtina", street: [
        "via Tiburtina, 545",
        "(Parcheggio convenzionato, via Galla Placidia, 9)"
      ], link: "https://www.google.com/maps/search/?q=Roma+Tiburtina,+via+Tiburtina,+545" },
    ],
  },
  {
    name: "Expert Mileto",
    addresses: [
      { city: "Roma Torrevecchia", street: "via Pietro Maffi, 181", link: "https://www.google.com/maps/search/?q=Roma+Torrevecchia,+via+Pietro+Maffi,+181" },
    ],
  },
  {
    name: "Expert City Elettrolelli",
    addresses: [
      { city: "Acilia", street: "Via Di Saponara, 61", link: "https://www.google.com/maps/search/?q=Acilia,+Via+Di+Saponara+61" },
      { city: "Acilia", street: "Via Macchia Palocco, angolo Via Pietro Audisio", link: "https://www.google.com/maps/search/?q=Via+Macchia+Palocco+angolo+Via+Pietro+Audisio" },
    ],
  },
  {
    name: "Expert Elettromix",
    addresses: [
      { city: "Civitavecchia", street: "Viale Palmiro Togliati, 9", link: "https://www.google.com/maps/search/?q=Civitavecchia,+Viale+Palmiro+Togliati,+9" },
      { city: "Ladispoli", street: "Piazza Giovanni Falcone, 26", link: "https://www.google.com/maps/search/?q=Ladispoli,+Piazza+Giovanni+Falcone,+26" },
      { city: "Cerveteri", street: "Via Sergio Angelucci, 3", link: "https://www.google.com/maps/search/?q=Cerveteri,+Via+Sergio+Angelucci,+3" },
    ],
  },
];

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* HERO SECTION */}
      <header className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          {/* LOGO Expert, visibile solo su mobile */}
          <img src={logo} alt="Expert Logo" className="hero-logo-mobile" />
          
          <h1>Negozi Expert Selezionati da Radio Radio</h1>
          <p>Innovazione e qualità a portata di mano</p>
        </div>
      </header>



      {/* STORES SECTION */}
      <section className="stores">
        <h2>I nostri partner selezionati</h2>
        <div className="store-cards">
          {stores.map((store, idx) => (
            <div className="store-card" key={idx}>
              <h3>{store.name}</h3>
              <div className="addresses">
                {store.addresses.map((addr, index) => (
                  <div key={index} className="address-item">
                    <a href={addr.link} target="_blank" rel="noopener noreferrer">
                      <span className="city">{addr.city}</span>
                      <p>-</p>
                      {Array.isArray(addr.street)
                        ? addr.street.map((line, index) => (
                            <React.Fragment key={index}>
                              {line}
                              <br />
                            </React.Fragment>
                          ))
                        : addr.street}
                    </a>
                    {/* Separator */}
                    {index < store.addresses.length - 1 && <div className="address-separator"></div>}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* BANNER1 SECTION: a due colonne con immagine e testo marketing */}
      <section className="banner1-section">
        <div className="banner1-image">
          <img src={banner1} alt="Banner 1" className="banner-img" />
        </div>
        <div className="banner1-text">
          <h2>Innovazione al tuo servizio</h2>
          <p>
            Scopri le ultime tecnologie e soluzioni esclusive nei nostri negozi.
            Siamo sempre all'avanguardia per offrirti il meglio dell'elettronica e
            del lifestyle.
          </p>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="cta">
        <h2>Contattaci</h2>
        <p>Numero dedicato Radio Radio</p>
        <div className="phone">
          <a href="tel:3514209888">351 420 98 88</a>
        </div>
        <button className="cta-button">
          <a
            href="tel:3514209888"
            style={{ color: "inherit", textDecoration: "none" }}
          >
            Chiamaci Ora
          </a>
        </button>
      </section>

      {/* BANNER3 SECTION */}
      <section className="banner3-section">
        <img src={banner3} alt="Banner 3" className="banner-img" />
      </section>
    </div>
  );
};

export default LandingPage;
